import Flickity from 'flickity';

const TICKERSPEED_DESKTOP = 0.5;
const TICKERSPEED_MOBILE = 0.4;

const flickitySlider = function (slideshowElement) {
  let flickity = null;
  let isPaused = false;

  const update = () => {
    if (isPaused) {
      return;
    }

    const tickerSpeed = window.BREAKPOINTS.isMobile ? TICKERSPEED_MOBILE : TICKERSPEED_DESKTOP;

    if (flickity.slides) {
      flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
      flickity.selectedIndex = flickity.dragEndRestingSelect();
      flickity.updateSelectedSlide();
      flickity.settle(flickity.x);
    }
    window.requestAnimationFrame(update);
  };

  const pause = () => {
    isPaused = true;
  };

  const play = () => {
    if (isPaused) {
      isPaused = false;
      window.requestAnimationFrame(update);
    }
  };

  flickity = new Flickity(slideshowElement, {
    autoPlay: false,
    prevNextButtons: false,
    pageDots: false,
    draggable: true,
    wrapAround: true,
    selectedAttraction: 0.015,
    friction: 0.25,
  });
  flickity.x = 0;

  slideshowElement.addEventListener('mouseenter', pause, false);
  slideshowElement.addEventListener('focusin', pause, false);
  slideshowElement.addEventListener('mouseleave', play, false);
  slideshowElement.addEventListener('focusout', play, false);

  flickity.on('dragStart', () => {
    isPaused = true;
  });

  update();
};

const flickitySliderBySelector = function (selector) {
  document.querySelectorAll(selector).forEach((element) => {
    flickitySlider(element);
  });
};

export { flickitySlider, flickitySliderBySelector };
